import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {Kpi} from '../../../../models/common';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {InfluencerCampaignPost} from '../../../../models/influencer-campaign';
import {PostListComponent} from '../../influencer/post-list/post-list.component';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {CommonConstant} from '../../../app.constants';
import {DateUtils} from '../../../utils/date.utils';
import {CampaignService} from '../../../services/campaign/campaign.service';
export enum ServiceCounter {
  staticComponents = 5,
  renderTimeout = 500
}
@Component({
  selector: 'campaign-pdf-viewer',
  templateUrl: './campaign-pdf-viewer.component.html',
  styleUrls: ['./campaign-pdf-viewer.component.scss']
})
export class CampaignPdfViewerComponent implements OnInit {
  static MAX_POST_ITEM = 8;
  private campaignInfluencerId: number;
  public influencer: any;
  public campaignPostDailyKpis: Array<object>;
  public campaignInfluencerKPI: Kpi | null;
  public campaignPosts: InfluencerCampaignPost[];
  public influencerPostList;
  public campaign: any;
  public groupId: number;
  public campaignPostPages: Array<any>;

  private numOfReportComponent: number;

  constructor(private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private influencerService: InfluencerService,
              private campaignService: CampaignService,
              private pdfExportService: PdfExportService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.campaignInfluencerId = Number(params.campaignInfluencerId);
    });
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (currentInfluencer) {
      this.getInfluencerDetails(currentInfluencer.id);
      this.getInfluencerPosts(currentInfluencer.id);
      this.loadDetailsCampaignInfluencer(this.campaignInfluencerId);
    }
    this.numOfReportComponent = ServiceCounter.staticComponents;
    this.pdfExportService.triggerIncrementReportReady.subscribe((numberReportReady) => {
      if (numberReportReady === this.numOfReportComponent) {
        console.log(' ***************************************** CAMPAIGN READY TO EXPORT PDF *****************************************');
        setTimeout(() => {
          this.pdfReady();
        }, ServiceCounter.renderTimeout);
      }
    });
  }

  private pdfReady () {
    if (window && typeof (<any>window).pdfReady === 'function') {
      setTimeout(() => {
        (<any>window).pdfReady();
      }, ServiceCounter.renderTimeout);
    }
  }

  private getInfluencerDetails(influencerId) {
    this.influencerService.getInfluencer(influencerId).subscribe((data) => {
      this.influencer = data;
    });
  }

  private loadDetailsCampaignInfluencer(campaignInfluencerId) {
    this.getCampaignInfluencerDetail(campaignInfluencerId);
    this.getCampaignBelongedToInfluencer(campaignInfluencerId);
  }

  private getCampaignInfluencerDetail(campaignInfluencerId: number) {
    this.influencerService.getCampaignInfluencerDetail(campaignInfluencerId).subscribe((res: any) => {
      if (res && res.campaign) {
        this.campaign = res.campaign;
      }
    });
  }

  private getCampaignBelongedToInfluencer(campaignInfluencerId) {
    this.getCampaignInfluencerData(campaignInfluencerId);
  }

  private getCampaignInfluencerData(campaignInfluencerId: number) {
    this.influencerService.getCampaignInfluencerData(campaignInfluencerId)
      .subscribe((res) => {
        // parse KPI
        const postKpi = new Kpi();
        postKpi.engagement.value = res.globalChannelKpi.engagement;
        postKpi.impact.value = res.globalChannelKpi.impact * 100;
        postKpi.impressions.value = res.globalChannelKpi.impression;
        postKpi.reach.value = res.globalChannelKpi.reach;
        postKpi.post.value = res.globalChannelKpi.post;
        this.campaignInfluencerKPI = postKpi;
        // parse post list
        const postList = res.postList.map(post => ({
          imageUrl: post.image,
          title: post.page_title,
          date: post.date,
          relativePath: post.relativePath,
          fullUrl: post.full_url,
          platformBlogs: post.platformBlogs,
          platformInstagram: post.platformInstagram,
          platformYoutube: post.platformYoutube,
          platformSnapchat: post.platformSnapchat,
          platformTwitter: post.platformTwitter,
          platformPinterest: post.platformPinterest,
          platformFacebook: post.platformFacebook,
          reach: post.reach.value,
          engagement: post.engagement.value,
          impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
          impact: post.impact.value,
          urlHash: post.urlHash
        }));
        this.campaignPosts = postList;
        this.calculateCampaignPostPage(postList.length);
        this.getCampaignPostDailyKpis(postList);
      });
  }

  private calculateCampaignPostPage(numOfList) {
    const totalFullPage = Math.floor(numOfList / CampaignPdfViewerComponent.MAX_POST_ITEM);
    const hasPartialPage = (numOfList % CampaignPdfViewerComponent.MAX_POST_ITEM) > 0;
    let numberOfCampaignPostPage;
    if (hasPartialPage) {
      numberOfCampaignPostPage = totalFullPage + 1;
    } else {
      numberOfCampaignPostPage = totalFullPage;
    }
    this.campaignPostPages = new Array(numberOfCampaignPostPage);
    this.numOfReportComponent += numberOfCampaignPostPage;
  }

  private getCampaignPostDailyKpis(campaignPosts) {
    if (!campaignPosts || campaignPosts.length === 0) {
      this.campaignPostDailyKpis = [];
      return;
    }
    const orderedPosts = campaignPosts.sort((p1, p2) => {
      const startDate1 = new Date(p1.date);
      const startDate2 = new Date(p2.date);
      return startDate1.getTime() - startDate2.getTime();
    });
    const fromDate = orderedPosts[0].date;
    const toDate = orderedPosts[orderedPosts.length - 1].date;
    this.campaignService.getCampaignPostDailyKpis(this.campaignInfluencerId, fromDate, toDate).subscribe((res) => {
      this.campaignPostDailyKpis = res;
    });
  }

  private getInfluencerPosts(influencerId: number) {
    const postListParams = {
      date: CommonConstant.PERIOD_30_DAYS,
      limit: CommonConstant.LIMIT_20,
    };
    this.influencerService.getInfluencerPosts(influencerId, postListParams)
      .subscribe(
        data => {
          data.forEach(item => {
            item.title  = item.title.replace(/\uFFFD/g, ''); // remove unknown character
            item.title = item.title.substring(0, 100) + '...'; // get 100 characters
          });
          this.influencerPostList = data;
          // if no posts, post list pdf module should be activated immediately
          if (this.influencerPostList.length === 0) {
            this.pdfExportService.incrementNumberReportReady(PostListComponent.COMPONENT_NAME);
          }
        }
      );
  }

  getSubPostList(pageNo) {
    const startIndex = pageNo * CampaignPdfViewerComponent.MAX_POST_ITEM;
    return this.campaignPosts.slice(startIndex, startIndex + CampaignPdfViewerComponent.MAX_POST_ITEM);
  }

  get canShowCampaignKpi() {
    return this.campaignInfluencerKPI;
  }

  get canShowInfluencerPostList() {
    return this.influencerPostList && this.influencerPostList.length > 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/campaign-pdf-viewer/campaign-pdf-viewer.component.ts